export default [
    {
        path: "/perfiles-usuario",
        name: "perfiles-usuario",
        component: () =>
            import(/* webpackChunkName: "estructuraStepper" */ "./index.vue"),
    },
    {
        path: "/perfiles-usuario/agregar",
        name: "perfiles-usuario-agregar",
        component: () => import(/* webpackChunkName: "estructura" */ "./formPerfil.vue"),
    },
    {
        path: "/perfiles-usuario/editar/:id",
        name: "perfiles-usuario-editar",
        component: () =>
            import(
                /* webpackChunkName: "nomina" */ "./formPerfil.vue"
            ),
    },
    {
        path: "/perfiles-usuario/ver/:id",
        name: "perfiles-usuario-ver",
        component: () =>
            import(
                /* webpackChunkName: "nomina" */ "./formPerfil.vue"
            ),
    },
];